import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from '../../services/notiflix.service';
import OwnedAssetService from '../../services/owned-asset.service';
import { useSelector } from 'react-redux';
import BarGraph from '../../components/common/BarGraph';
import { RightArrowIcon } from '../../components/common/IconProvider';
import { formatNumber } from '../../utils/Helper';
import ProjectListingRootComponent from '../../components/common/projectListing/ProjectListingRootComponent';
import { useTranslation } from 'react-i18next';
const OwnedAssets = () => {
  const { user: _authUser } = useSelector((state) => state.auth);
  const [ownedAssetLists, setOwnedAssetList] = useState([]);
  const [projectInvestedAmount, setProjectInvestedAmount] = useState(0);
  const [totalPaidDividendAmount, setTotalPaidDividendAmount] = useState(0);
  const [ownedAssetLoading, setownedAssetLoading] = useState(true);
  const [isView, setView] = useState(2);
  const [sortBy, setSortBy] = useState('');
  const [isBarData, setBarData] = useState(null);
  const { t } = useTranslation('ownedAssets');
  const [isDropDownList, setDropDownList] = useState([]);
  const [isSortingLoader, setSortingLoader] = useState(false);
  const [isPagination, setPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });

  useEffect(() => {
    setDropDownList([
      {
        name: t('order_by_investment'),
        value: '',
      },
      {
        name: t('big_to_small_investment'),
        value: 'high_to_low',
      },
      {
        name: t('small_to_big_investment'),
        value: 'low_to_high',
      },
    ]);
  }, [t]);
  const [filterOwnedAssetData, setOwnedAssetData] = useState({
    perPage: 10,
    page: 1,
    commonSearch: '',
    sortBy: '',
    investmentType: '',
    user_id: _authUser.userId,
  });

  useEffect(() => {
    ownedAssetList();
  }, [filterOwnedAssetData]);

  const ownedAssetList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setownedAssetLoading(true); // Show pagination loader
      }
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let ownedAssetListRes = await OwnedAssetService.list(
        filterOwnedAssetData.perPage,
        currentPage,
        filterOwnedAssetData.commonSearch,
        filterOwnedAssetData.sortBy,
        filterOwnedAssetData.user_id,
        filterOwnedAssetData.investmentType,
        field,
        order,
      );
      if (ownedAssetListRes.status === 'failure') {
        setownedAssetLoading(false);
        setSortingLoader(false);
        Alert.error(ownedAssetListRes.message);
        return false;
      }

      const records = ownedAssetListRes?.data?.records ?? [];
      setOwnedAssetList(records);
      setBarData(ownedAssetListRes?.data ?? {});
      setProjectInvestedAmount(
        ownedAssetListRes?.data?.project_invested_amount,
      );
      setTotalPaidDividendAmount(
        ownedAssetListRes?.data?.total_paid_payout_amount,
      );
      setOwnedAssetList(ownedAssetListRes?.data?.records);
      setPagination({
        totalPages: ownedAssetListRes.data.pagination.totalPages,
        currentPage: ownedAssetListRes.data.pagination.page,
      });
      setownedAssetLoading(false);
      setSortingLoader(false);
    } catch (error) {
      setownedAssetLoading(false);
      setSortingLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  const searchData = async (_action, _value) => {
    if (
      _action === 'investmentType' &&
      _value === filterOwnedAssetData.investmentType
    )
      return false;
    setownedAssetLoading(true);
    setSortBy(_value);
    setOwnedAssetData({
      ...filterOwnedAssetData,
      page: 1,
      [_action]: _value,
    });
  };

  return (
    <>
      <div className=""></div>
      <div className="md:py-5 md:pl-5">
        <div className=" text-center my-24 dark:text-slate-200">
          <h2>{t('personal_portfolio')}</h2>
          <p className="mt-2">{t('view_performance_and_owned')}</p>
        </div>
        <div>
          <div className="md:grid gap-5 md:grid-cols-2">
            <div className="bg-[#F3F3F3] dark:bg-slate-800 dark:text-slate-200 p-4 rounded-md mb-2 md:mb-0">
              <div className="flex justify-between items-center">
                <div className="font-semibold">{t('total_invested')}</div>
                <div className="font-semibold">
                  {formatNumber(projectInvestedAmount)}
                </div>
              </div>
              {projectInvestedAmount > 0 && (
                <div className="block rounded-md overflow-hidden relative w-full">
                  <BarGraph
                    graphData={isBarData?.projectType}
                    totalAmount={projectInvestedAmount || '0'}
                  />

                  <p className="absolute left-0 bottom-2 text-slate-500 font-medium">
                    {' '}
                    <span className="w-3 h-3 rounded-xl bg-slate-500 inline-block mr-2"></span>{' '}
                    {t('hover_chart_project_info')}
                  </p>
                </div>
              )}
              {projectInvestedAmount === null && (
                <div className="bg-white p-5 block md:flex items-center justify-between rounded-md my-10">
                  <p className="text-base font-medium text-brandBlue">
                    {t('not_invested_yet')}
                  </p>
                  <Link
                    className="text-blue-700 font-medium inline-flex items-center"
                    to={'/assets'}
                  >
                    {t('start_investing')} <RightArrowIcon />
                  </Link>
                </div>
              )}
              <div className="text-[#85919F]"></div>
            </div>
            <div className="bg-[#F3F3F3] dark:bg-slate-800 dark:text-slate-200 p-4 rounded-md">
              <div className="flex justify-between items-center ">
                <div className="font-semibold">{t('payout_received')}</div>
                <div className="font-semibold">
                  {formatNumber(totalPaidDividendAmount, {
                    decimalPlaces: 2,
                  })}
                </div>
              </div>
              <div className="block  overflow-hidden relative w-full">
                {totalPaidDividendAmount > 0 && (
                  <>
                    <BarGraph
                      graphData={isBarData?.user_payouts}
                      totalAmount={totalPaidDividendAmount || '0'}
                      className="w-full"
                    />
                    <p className="absolute left-0 bottom-2 text-slate-500 font-medium">
                      {' '}
                      <span className="w-3 h-3 rounded-xl bg-slate-500 inline-block mr-2 "></span>{' '}
                      {t('hover_chart_project_info')}
                    </p>
                  </>
                )}
                {totalPaidDividendAmount === 0 ||
                  (totalPaidDividendAmount === null && (
                    <div className="bg-white p-5 block md:flex items-center justify-between rounded-md my-10">
                      <p className="text-base font-semibold text-brandBlue text-center">
                        {t('not_received_payouts_yet')}
                      </p>
                    </div>
                  ))}
              </div>
              <div className="text-[#85919F] dark:text-slate-300"></div>
            </div>
          </div>
        </div>
        <ProjectListingRootComponent
          headerText={t('owned_assets')}
          projectLists={ownedAssetLists}
          message={t('not_invested_in_project')}
          slug={'owned-assets'}
          projectLoading={ownedAssetLoading}
          count={4}
          searchData={searchData}
          filterData={filterOwnedAssetData}
          isDropDownList={isDropDownList}
          value={sortBy}
          isView={isView}
          setView={setView}
          isSortingLoader={isSortingLoader}
          list={ownedAssetList}
          isPagination={isPagination}
          setPagination={setPagination}
          isListLoader={ownedAssetLoading}
        />
      </div>
    </>
  );
};
export default OwnedAssets;
